import React from 'react';
import { Upload } from 'lucide-react';
import { OnboardingStatusBanner } from '../onboarding/components/OnboardingStatusBanner';

interface DatabaseUploadStatusBannerProps {
  organization: any;
}

/**
 * Banner to show database upload in progress status
 * Displays on Flows pages for non-FUB users after submitting an upload request
 * Checks organization.databaseUploads array for any pending uploads
 */
export const DatabaseUploadStatusBanner: React.FC<DatabaseUploadStatusBannerProps> = ({
  organization,
}) => {
  // Check if there are any pending database uploads
  const databaseUploads = organization?.databaseUploads;
  const hasPendingUploads =
    Array.isArray(databaseUploads) &&
    databaseUploads.some((upload: { id: string; status: string }) => upload.status === 'pending');

  // Don't show banner if no pending uploads
  if (!hasPendingUploads) return null;

  return (
    <OnboardingStatusBanner
      icon={Upload}
      title="Database Upload In Progress"
      variant="orange"
      defaultMinimized={true}
    >
      <p className="text-xs">
        Our team is busy getting all your contacts securely tucked into your account and ready for
        launch flows. Keep an eye on your inbox—we'll let you know the second the upload is
        complete!
      </p>
    </OnboardingStatusBanner>
  );
};
